import { BaseObject } from "../../../../../shared/baseObject";
import * as Immutable from "immutable";

export abstract class BaseCommand extends BaseObject {

  extraArgs?: Immutable.Map<string, string>;
}